/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExposureTypes = {
    IS_PAYDAY_BOND: 'is_payday_bond'
} as const;
export type ExposureTypes = typeof ExposureTypes[keyof typeof ExposureTypes];


export function instanceOfExposureTypes(value: any): boolean {
    for (const key in ExposureTypes) {
        if (Object.prototype.hasOwnProperty.call(ExposureTypes, key)) {
            if (ExposureTypes[key as keyof typeof ExposureTypes] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExposureTypesFromJSON(json: any): ExposureTypes {
    return ExposureTypesFromJSONTyped(json, false);
}

export function ExposureTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExposureTypes {
    return json as ExposureTypes;
}

export function ExposureTypesToJSON(value?: ExposureTypes | null): any {
    return value as any;
}

export function ExposureTypesToJSONTyped(value: any, ignoreDiscriminator: boolean): ExposureTypes {
    return value as ExposureTypes;
}

